module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-94964bb4.png";